module.exports = __webpack_public_path__ + "static/media/app-store-badge.df472347.svg";